import { useCallback } from 'react';
import { useApiCall } from '@/hooks/useApiCall';
import { useApiClient } from '@/hooks/useApiClient';
import { mlListToolsForProcess } from '@/features/machine-learning/api/MLApiClient';
import type { MLProcessSummary, MLToolSummary } from '@/features/machine-learning/type/MLTypes';
import type { BaseResponse } from '@/lib/http/HttpClient';

type MLToolsResponse = BaseResponse & { items: MLToolSummary[] };

export function useMLTools(process: MLProcessSummary | null) {
  const http = useApiClient();
  const apiFn = useCallback(
    async (_signal: AbortSignal) => {
      const items = await mlListToolsForProcess(process!.id, process!.toolReference, http ?? undefined);
      return {
        ok: true as const,
        data: { timestamp: new Date().toISOString(), items },
      };
    },
    [process, http]
  );

  const { data, isLoading, error, retry } = useApiCall<MLToolsResponse>({
    apiFn,
    immediate: process !== null,
    deps: [process?.id ?? null],
  });

  return {
    data: data?.items ?? null,
    isLoading,
    error,
    retry,
  };
}
